export default "__VITE_ASSET__CqPR5nL4YDDwNUsPgo$6sA__"